import type { BrandFilterStateSet } from '../state/brand';
import {
  BrandFilterStateSet as BrandFilterStateSetSchema,
  BrandUuid as BrandUuidSchema,
} from '../state/brand';
import { Chunk, HashSet, pipe, Schema, SchemaGetter } from 'effect';

const brandFilterStateSetToUrlArray = (brandSet: BrandFilterStateSet): string[] =>
  pipe(brandSet, Chunk.fromIterable, Chunk.toArray);

const urlArrayToBrandFilterStateSet = (brandArray: readonly string[]): BrandFilterStateSet =>
  pipe(
    brandArray,
    Chunk.fromIterable,
    Chunk.filter((s) => s.length > 0),
    Chunk.map((s) => BrandUuidSchema.make(s)),
    HashSet.fromIterable
  );

export const BrandSerializable = Schema.String.pipe(
  Schema.decodeTo(Schema.toType(BrandFilterStateSetSchema), {
    decode: SchemaGetter.transform((str) =>
      urlArrayToBrandFilterStateSet(str.split(',').filter((s) => s.length > 0))
    ),
    encode: SchemaGetter.transform((brandSet) => brandFilterStateSetToUrlArray(brandSet).join(',')),
  })
);

export const BrandUrlQuery = Schema.Struct({
  brand: Schema.optional(Schema.Array(Schema.String)),
});

export const BrandToUrl = Schema.toType(BrandFilterStateSetSchema).pipe(
  Schema.decodeTo(BrandUrlQuery, {
    decode: SchemaGetter.transform((brandSet) => {
      const brandArray = brandFilterStateSetToUrlArray(brandSet);
      return brandArray.length > 0 ? { brand: brandArray } : {};
    }),
    encode: SchemaGetter.transform((urlData) => urlArrayToBrandFilterStateSet(urlData.brand ?? [])),
  })
);
